export default "__VITE_ASSET__O_DOwRCS__"